
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Login from '../components/Auth/Login';

//import actions
import { loginUser } from '../actions/userActions';

const mapStateToProps = state => ({ user: state.user });

const mapDispatchToProps = { loginUser };


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/pages/Login.js